import api from '../services/api';
import { clearConsentCookie } from './cookieConsent';
import { clearTrackingScripts } from './trackingScripts';

/**
 * Revoke cookie consent and reload the page to show banner again
 */
export async function revokeCookieConsent() {
  try {
    clearConsentCookie();
    clearTrackingScripts();

    try {
      await api.delete('/cookie-consent');
    } catch (error) {
      console.error('Error deleting backend consent:', error);
    }

    window.location.reload();
  } catch (error) {
    console.error('Error revoking consent:', error);
    window.location.reload();
  }
}

/**
 * Get current cookie consent status
 */
export async function getCookieConsent() {
  try {
    const response = await api.get('/cookie-consent');
    return response.data;
  } catch (error) {
    console.error('Error getting consent:', error);
    return null;
  }
}
